// Traductions françaises
const fr = {
  "common": {
    "loading": "Chargement...",
    "error": "Erreur",
    "success": "Succès",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "delete": "Supprimer",
    "edit": "Modifier",
    "add": "Ajouter",
    "create": "Créer",
    "search": "Rechercher",
    "filter": "Filtrer",
    "export": "Exporter",
    "import": "Importer",
    "close": "Fermer",
    "confirm": "Confirmer",
    "yes": "Oui",
    "no": "Non",
    "all": "Tous",
    "active": "Actif",
    "inactive": "Inactif",
    "today": "Aujourd'hui",
    "week": "Cette semaine",
    "month": "Ce mois",
    "lastMonth": "Mois dernier",
    "year": "Cette année",
    "customDateRange": "Plage de dates",
    "date": "Date",
    "type": "Type",
    "amount": "Montant",
    "status": "Statut",
    "actions": "Actions",
    "name": "Nom",
    "email": "Email",
    "phone": "Téléphone",
    "location": "Localisation",
    "bamako": "Bamako",
    "dubai": "Dubaï",
    "buy": "Achat",
    "sell": "Vente",
    "wait": "Attendre",
    "details": "Détails",
    "receipt": "Reçu",
    "whatsapp": "WhatsApp",
    "exportPdf": "Exporter en PDF",
    "exportExcel": "Exporter en Excel",
    "update": "Mettre à jour",
    "register": "Enregistrer",
    "submit": "Soumettre",
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "total": "Total",
    "average": "Moyenne",
    "minimum": "Minimum",
    "maximum": "Maximum",
    "opened": "Ouvert",
    "closed": "Clôturé",
    "raw": "Brut",
    "refined": "Raffiné",
    "theoretical": "Théorique",
    "real": "Réel",
    "difference": "Écart",
    "alert": "Alerte",
    "noData": "Aucune donnée disponible",
    "loadingData": "Chargement des données...",
    "noResults": "Aucun résultat trouvé",
    "locale": "fr-FR"
  },
  "navigation": {
    "home": "Accueil",
    "dashboard": "Dashboard",
    "transaction": "Transaction",
    "transactions": "Historique",
    "positions": "Positions",
    "stock": "Stock",
    "margins": "Marges",
    "reports": "Rapports",
    "swift": "SWIFT",
    "admin": "Admin",
    "profile": "Profil",
    "settings": "Paramètres",
    "logout": "Déconnexion",
    "login": "Connexion"
  },
  "landing": {
    "title": "Golden Mali SARL",
    "subtitle": "Plateforme SaaS - Gestion Professionnelle de l'Or",
    "description": "Plateforme SaaS complète pour le suivi, l'estimation et l'optimisation de vos flux d'or et métaux précieux. Accès en ligne 24/7 avec synchronisation automatique et sauvegarde sécurisée en cloud.",
    "cta": {
      "dashboard": "Accéder au Dashboard",
      "transaction": "Nouvelle Transaction"
    },
    "hero": {
      "title": "Golden Mali SARL",
      "subtitle": "Plateforme SaaS - Gestion Professionnelle de l'Or",
      "description": "Système de gestion complet pour le suivi, l'estimation et l'optimisation de vos flux d'or et métaux précieux. Accès web disponible pour les mises à jour, transferts de données et synchronisation entre vos appareils.",
      "loginButton": "Se connecter pour accéder",
      "carousel": {
        "image1": {
          "title": "Graphiques Financiers",
          "subtitle": "Analyse de Marché - Tendances Ascendantes"
        },
        "image2": {
          "title": "Trading Professionnel",
          "subtitle": "Suivi en Temps Réel - Décisions Éclairées"
        },
        "image3": {
          "title": "Analyse de Performance",
          "subtitle": "Barres de Données - Évolution Continue"
        },
        "image4": {
          "title": "Interface Moderne",
          "subtitle": "Technologie Avancée - Gestion Interactive"
        },
        "image5": {
          "title": "Croissance & Expansion",
          "subtitle": "Flux Financiers - Optimisation des Rendements"
        }
      },
      "loginLink": "Connexion"
    },
    "restricted": {
      "title": "Accès Restreint",
      "description": "Cette plateforme est réservée aux utilisateurs autorisés.",
      "mustRequest": "Vous devez demander l'accès au propriétaire de la plateforme",
      "howToGet": "Comment obtenir l'accès ?",
      "step1": "Contactez le propriétaire ou l'administrateur de la plateforme",
      "step2": "Demandez la création d'un compte utilisateur",
      "step3": "Recevez vos identifiants de connexion par email",
      "step4": "Connectez-vous avec vos identifiants pour accéder à la plateforme",
      "alreadyHave": "J'ai déjà un accès - Se connecter",
      "mobileStores": {
        "title": "Applications mobiles",
        "subtitle": "Golden Mali sera bientôt disponible sur Google Play et l'App Store.",
        "comingSoon": "Bientôt disponible",
        "scanHint": "Scannez pour accéder au store (publication prochaine)",
        "qrAlt": "QR code {{platform}} Golden Mali",
        "directLink": "Lien store :",
        "androidTitle": "Application Android",
        "androidDescription": "Gérez vos opérations or depuis Android, synchronisées en temps réel avec la plateforme web.",
        "iosTitle": "Application iOS",
        "iosDescription": "Même puissance que le web sur iPhone et iPad — disponible prochainement sur l'App Store.",
        "playStoreButton": "Google Play Store",
        "appStoreButton": "Apple App Store"
      }
    },
    "features": {
      "title": "Fonctionnalités Principales",
      "subtitle": "Découvrez les principales fonctionnalités de notre plateforme de gestion professionnelle de l'or",
      "dashboard": {
        "title": "Dashboard de Décision",
        "description": "Vue d'ensemble en temps réel avec recommandations d'achat/vente basées sur les marges actuelles."
      },
      "transactions": {
        "title": "Gestion des Transactions",
        "description": "Enregistrement ultra-rapide des transactions avec suivi complet et historique détaillé."
      },
      "positions": {
        "title": "Positions Ouvertes",
        "description": "Suivi en temps réel des positions avec calcul automatique des marges et profits potentiels."
      },
      "stock": {
        "title": "Stock Physique",
        "description": "Gestion du stock par localisation avec alertes et inventaire en temps réel."
      },
      "margins": {
        "title": "Marges & Profits",
        "description": "Vision claire des marges réalisées avec graphiques de tendances et prévisions."
      },
      "history": {
        "title": "Historique Complet",
        "description": "Recherche avancée et export PDF/Excel pour vos rapports et analyses comptables."
      }
    },
    "security": {
      "title": "Sécurité & Confidentialité",
      "dataSecure": {
        "title": "Données Sécurisées",
        "description": "Protection des données sensibles avec authentification obligatoire"
      },
      "accessControlled": {
        "title": "Accès Contrôlé",
        "description": "Gestion des accès par rôle administrateur et permissions"
      },
      "cloudSync": {
        "title": "Synchronisation Cloud",
        "description": "Sauvegarde automatique et synchronisation en temps réel"
      },
      "availability": {
        "title": "Disponibilité 24/7",
        "description": "Accès web disponible à tout moment depuis n'importe quel appareil"
      }
    }
  },
  "login": {
    "title": "Golden Mali SARL",
    "subtitle": "Plateforme SaaS - Connexion",
    "email": "Email ou Nom d'utilisateur",
    "password": "Mot de passe",
    "submit": "Se connecter",
    "submitting": "Connexion...",
    "error": "Erreur de connexion",
    "version": "Version 1.0 - Golden Mali SARL"
  },
  "dashboard": {
    "title": "Dashboard de Décision",
    "personalize": "Personnaliser",
    "editMode": "Mode édition",
    "exitEditMode": "Terminer",
    "widgets": {
      "decision": {
        "title": "Recommandation",
        "buy": "ACHETER",
        "sell": "VENDRE",
        "wait": "ATTENDRE"
      },
      "goldPrice": {
        "title": "Prix de l'Or",
        "current": "Prix actuel",
        "change": "Variation"
      },
      "margin": {
        "title": "Marge Actuelle",
        "current": "Marge actuelle"
      },
      "profit": {
        "title": "Profit Potentiel",
        "potential": "Profit potentiel"
      },
      "priceChart": {
        "title": "Évolution du Prix",
        "price": "Prix"
      }
    },
    "loading": "Chargement du dashboard...",
    "noData": "Aucune donnée disponible"
  },
  "home": {
    "features": {
      "title": "Fonctionnalités Principales",
      "subtitle": "Découvrez les outils puissants qui vous permettront de gérer efficacement vos opérations d'or et métaux précieux",
      "dashboard": {
        "title": "Dashboard de Décision",
        "description": "Vue d'ensemble en temps réel avec recommandations d'achat/vente basées sur les marges actuelles. Graphiques interactifs et indicateurs de performance clés pour une prise de décision éclairée.",
        "access": "Accéder à Dashboard de Décision"
      },
      "transactions": {
        "title": "Gestion des Transactions",
        "description": "Enregistrement ultra-rapide des transactions en 30 secondes. Suivi complet des flux avec historique détaillé et recherche avancée pour une traçabilité totale.",
        "access": "Accéder à Gestion des Transactions"
      },
      "positions": {
        "title": "Positions Ouvertes",
        "description": "Suivi en temps réel des positions ouvertes avec calcul automatique des marges et profits potentiels. Alertes et notifications intelligentes pour optimiser vos décisions.",
        "access": "Accéder à Positions Ouvertes"
      },
      "stock": {
        "title": "Stock Physique",
        "description": "Gestion du stock par localisation (Bamako/Dubaï) avec alertes de différences théorique/réel. Inventaire en temps réel et rapports détaillés pour un contrôle optimal.",
        "access": "Accéder à Stock Physique"
      },
      "history": {
        "title": "Historique Complet",
        "description": "Recherche avancée et filtres multiples pour analyser toutes vos transactions passées. Export PDF et Excel pour vos rapports et analyses comptables.",
        "access": "Accéder à Historique Complet"
      },
      "margins": {
        "title": "Marges & Profits",
        "description": "Vision claire des marges réalisées et profits avec évolution mensuelle. Graphiques de tendances et prévisions basées sur les données historiques pour maximiser vos rendements.",
        "access": "Accéder à Marges & Profits"
      }
    },
    "architecture": {
      "title": "Architecture & Accès",
      "subtitle": "Plateforme SaaS accessible en ligne avec synchronisation en temps réel et sauvegarde automatique",
      "cloud": {
        "title": "Accès Cloud & Synchronisation",
        "description": "Plateforme SaaS accessible depuis n'importe quel appareil connecté à internet. Synchronisation automatique en temps réel de toutes vos données entre vos différents appareils."
      },
      "availability": {
        "title": "Disponibilité 24/7",
        "description": "Accès permanent à votre plateforme depuis n'importe où dans le monde. Disponibilité garantie 24h/24 et 7j/7 pour une gestion continue de vos opérations."
      },
      "traceability": {
        "title": "Traçabilité & Rapports",
        "description": "Suivez chaque transaction avec un historique complet. Générez des rapports PDF et Excel pour vos analyses et besoins comptables."
      },
      "security": {
        "title": "Sécurité & Fiabilité",
        "item1": "Chiffrement des données sensibles",
        "item2": "Sauvegarde locale automatique",
        "item3": "Sauvegarde automatique en cloud",
        "item4": "Transferts sécurisés via accès web",
        "discover": "Découvrir l'ERP"
      }
    },
    "cta": {
      "title": "Prêt à Optimiser vos Flux d'Or ?",
      "description": "Accédez dès maintenant à votre dashboard pour prendre les meilleures décisions basées sur des données précises et des analyses en temps réel.",
      "subdescription": "Commencez dès aujourd'hui et transformez votre gestion d'or et métaux précieux.",
      "dashboard": "Accéder au Dashboard",
      "transaction": "Créer une Transaction"
    }
  },
  "transactions": {
    "title": "Historique des Transactions",
    "advancedSearch": "Recherche Avancée",
    "searchType": "Type de recherche",
    "searchPlaceholder": "Entrez votre recherche...",
    "searchTypes": {
      "transactionId": "Numéro de transaction",
      "name": "Nom",
      "surname": "Prénom",
      "amount": "Montant",
      "idNumber": "Numéro pièce d'identité"
    },
    "status": "Statut",
    "allStatus": "Toutes",
    "closed": "Clôturées",
    "open": "Positions Ouvertes",
    "period": "Période",
    "allPeriod": "Toutes",
    "today": "Aujourd'hui",
    "week": "Cette semaine",
    "month": "Ce mois",
    "lastMonth": "Mois dernier",
    "customDateRange": "Plage de dates",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "counter": "Comptoir",
    "allCounters": "Tous les comptoirs",
    "partner": "Partenaire",
    "allPartners": "Tous les partenaires",
    "table": {
      "txNumber": "Numéro TX",
      "date": "Date",
      "type": "Type",
      "amount": "Montant",
      "counter": "Comptoir",
      "partner": "Partenaire",
      "margin": "Marge",
      "status": "Statut",
      "actions": "Actions"
    },
    "loading": "Chargement des transactions...",
    "noTransactions": "Aucune transaction trouvée",
    "details": {
      "title": "Détails de la Transaction",
      "generalInfo": "Informations Générales",
      "date": "Date",
      "type": "Type",
      "amount": "Montant",
      "counter": "Comptoir",
      "partner": "Partenaire",
      "margin": "Marge",
      "status": "Statut",
      "history": "Historique des Modifications",
      "noHistory": "Aucune modification enregistrée pour cette transaction",
      "field": "Modification",
      "action": {
        "create": "Création",
        "update": "Modification",
        "delete": "Suppression",
        "other": "Action"
      },
      "user": "Utilisateur inconnu",
      "oldValue": "Ancienne valeur:",
      "newValue": "Nouvelle valeur:",
      "close": "Fermer"
    },
    "export": {
      "pdf": "Exporter en PDF",
      "excel": "Exporter en Excel",
      "title": "Historique des Transactions",
      "exported": "Exporté le:",
      "headers": {
        "txNumber": "Num TX",
        "date": "Date",
        "type": "Type",
        "amount": "Montant",
        "counter": "Comptoir",
        "partner": "Partenaire",
        "margin": "Marge",
        "status": "Statut"
      },
      "total": "Total: {count} transaction(s)"
    }
  },
  "transactionForm": {
    "title": "Nouvelle Transaction",
    "txNumber": "Numéro de Transaction",
    "type": "Type de Transaction",
    "buy": "ACHAT",
    "sell": "VENTE",
    "amount": "Montant",
    "currency": "Devise",
    "counter": "Comptoir",
    "bamako": "BAMAKO",
    "dubai": "DUBAÏ",
    "goldDetails": {
      "title": "Détails Or (Optionnel)",
      "executablePrice": "Prix Or Exécutable (USD/oz)",
      "executablePricePlaceholder": "Prix réellement utilisé",
      "caratGross": "Carat Brut",
      "caratGrossPlaceholder": "Ex: 22",
      "weightGross": "Poids Brut (g)",
      "weightGrossPlaceholder": "0.00",
      "caratNet": "Carat Net",
      "caratNetPlaceholder": "Ex: 24",
      "weightNet": "Poids Net (g)",
      "weightNetPlaceholder": "0.00",
      "calculations": {
        "title": "Calculs Automatiques",
        "lossRate": "Taux de Perte",
        "yieldRate": "Taux de Rendement",
        "realValue": "Valeur Réelle (estimée)",
        "weightLost": "Poids perdu:",
        "marginImpact": "Impact sur marge:",
        "basedOnNet": "Basée sur poids net",
        "netOverGross": "Poids net / Poids brut",
        "grossToNet": "{gross}g → {net}g"
      },
      "partner": "Partenaire (optionnel)",
      "partnerPlaceholder": "Nom du partenaire"
    },
    "submit": "ENREGISTRER",
    "success": "Transaction enregistrée avec succès !",
    "error": "Erreur lors de l'enregistrement de la transaction"
  },
  "positions": {
    "title": "Positions Ouvertes",
    "summary": {
      "weightedAvgPrice": "Prix Moyen Pondéré",
      "latentPnL": "PnL Latent",
      "totalExposure": "Exposition Totale",
      "totalQuantity": "Quantité Totale"
    },
    "filters": {
      "counter": "Comptoir",
      "all": "Tous",
      "type": "Type",
      "allTypes": "Tous",
      "raw": "Brut",
      "refined": "Raffiné"
    },
    "table": {
      "txNumber": "Numéro TX",
      "buyDate": "Date Achat",
      "buyPrice": "Prix Achat",
      "quantity": "Quantité",
      "currentPrice": "Prix Actuel",
      "latentPnL": "PnL Latent",
      "counter": "Comptoir",
      "type": "Type",
      "carat": "Carat"
    },
    "loading": "Chargement des positions...",
    "noPositions": "Aucune position ouverte",
    "export": {
      "pdf": "Exporter PDF",
      "excel": "Exporter Excel",
      "title": "Positions Ouvertes",
      "exported": "Exporté le:",
      "globalSummary": "Résumé Global",
      "weightedAvgPrice": "Prix Moyen Pondéré:",
      "latentPnL": "PnL Latent Total:",
      "totalExposure": "Exposition Totale:",
      "totalQuantity": "Quantité Totale:",
      "headers": {
        "txNumber": "Num TX",
        "date": "Date",
        "buyPrice": "Prix Achat",
        "quantity": "Quantité",
        "currentPrice": "Prix Actuel",
        "latentPnL": "PnL Latent",
        "counter": "Comptoir",
        "type": "Type",
        "carat": "Carat"
      },
      "total": "Total: {count} position(s) ouverte(s)",
      "summary": "RÉSUMÉ"
    }
  },
  "stock": {
    "title": "Stock Physique",
    "bamako": "Stock Bamako",
    "dubai": "Stock Dubaï",
    "raw": "Brut",
    "refined": "Raffiné",
    "theoretical": "Théorique:",
    "real": "Réel:",
    "alert": "⚠️ Alerte: Écart de {percent}%",
    "totalConsolidated": "Stock Total Consolidé",
    "totalRaw": "Total Brut",
    "totalRefined": "Total Raffiné",
    "update": "Mettre à jour Stock Réel",
    "updateModal": {
      "title": "Mettre à jour le Stock Réel",
      "counter": "Comptoir",
      "type": "Type",
      "realStock": "Stock Réel (g)",
      "realStockPlaceholder": "0.000",
      "save": "Enregistrer",
      "cancel": "Annuler"
    },
    "success": "Stock mis à jour avec succès",
    "error": "Erreur lors de la mise à jour du stock",
    "loading": "Chargement du stock...",
    "loadingSubtitle": "Récupération des données",
    "export": {
      "pdf": "Exporter PDF",
      "excel": "Exporter Excel",
      "title": "État du Stock Physique",
      "location": "Lieu",
      "type": "Type",
      "theoretical": "Stock Théorique (g)",
      "real": "Stock Réel (g)",
      "difference": "Écart (g)",
      "differencePercent": "Écart (%)"
    }
  },
  "margins": {
    "title": "Marges et Profits",
    "filters": {
      "period": "Période",
      "currency": "Affichage Devises",
      "currencyOptions": {
        "usd": "USD uniquement",
        "aed": "AED uniquement",
        "both": "USD et AED"
      }
    },
    "summary": {
      "totalBought": "Total Acheté ({period})",
      "totalSold": "Total Vendu ({period})",
      "realizedMargin": "Marge Réalisée",
      "netProfit": "Profit Net"
    },
    "chart": {
      "title": "Évolution Mensuelle",
      "subtitle": "Comparaison Achat, Vente et Profit",
      "noData": "Aucune donnée disponible",
      "noDataSubtitle": "Les données apparaîtront après vos premières transactions",
      "labels": {
        "buy": "Achat",
        "sell": "Vente",
        "profit": "Profit"
      }
    },
    "export": {
      "pdf": "Exporter Rapport (PDF)",
      "excel": "Exporter Données (Excel)",
      "title": "Rapport Marges et Profits",
      "totalBought": "Total Acheté:",
      "totalSold": "Total Vendu:",
      "realizedMargin": "Marge Réalisée:",
      "netProfit": "Profit Net:"
    },
    "loading": "Chargement des marges...",
    "loadingSubtitle": "Calcul en cours"
  },
  "reports": {
    "title": "Rapports & Analytics",
    "subtitle": "Analyse détaillée de vos performances et données",
    "types": {
      "overview": "Vue d'ensemble",
      "transactions": "Transactions",
      "margins": "Marges",
      "positions": "Positions"
    },
    "filters": {
      "title": "Filtres",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "location": "Localisation",
      "allLocations": "Toutes",
      "type": "Type",
      "allTypes": "Tous"
    },
    "export": {
      "pdf": "Exporter en PDF",
      "excel": "Exporter en Excel"
    },
    "overview": {
      "totalTransactions": "Total Transactions",
      "totalVolume": "Volume Total",
      "totalProfit": "Profit Total",
      "avgMargin": "Marge Moyenne",
      "byDay": "Transactions par Jour",
      "byType": "Transactions par Type",
      "byLocation": "Transactions par Localisation",
      "profitTrend": "Tendance des Profits"
    },
    "margins": {
      "title": "Évolution des Marges",
      "buy": "Achat",
      "sell": "Vente",
      "profit": "Profit"
    },
    "positions": {
      "title": "Positions par Localisation",
      "quantity": "Quantité (g)",
      "exposure": "Exposition ($)"
    },
    "exportPdf": {
      "title": "Rapport Analytics Avancé",
      "period": "Période:",
      "exported": "Exporté le:",
      "overview": "Vue d'ensemble",
      "totalTransactions": "Total Transactions:",
      "totalVolume": "Volume Total:",
      "totalProfit": "Profit Total:",
      "avgMargin": "Marge Moyenne:",
      "byType": "Transactions par Type",
      "type": "Type",
      "count": "Nombre"
    },
    "loading": "Chargement du rapport..."
  },
  "admin": {
    "title": "Administration",
    "subtitle": "Interface réservée au super administrateur",
    "connectedAs": "Connecté en tant que :",
    "tabs": {
      "partners": "Partenaires",
      "users": "Utilisateurs"
    },
    "partners": {
      "add": "NOUVEAU PARTENAIRE",
      "table": {
        "name": "Nom",
        "email": "Email",
        "phone": "Téléphone",
        "company": "Société",
        "location": "Localisation",
        "status": "Statut",
        "actions": "Actions"
      },
      "noPartners": "Aucun partenaire enregistré",
      "modal": {
        "add": "Ajouter un Partenaire",
        "edit": "Modifier le Partenaire",
        "fullName": "Nom complet *",
        "email": "Email *",
        "phone": "Téléphone",
        "company": "Société",
        "location": "Localisation *",
        "status": "Statut *",
        "notes": "Notes",
        "addButton": "Ajouter",
        "saveButton": "Enregistrer"
      },
      "deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce partenaire ?",
      "success": {
        "add": "Partenaire ajouté avec succès !",
        "edit": "Partenaire modifié avec succès !",
        "delete": "Partenaire supprimé avec succès !"
      }
    },
    "users": {
      "add": "NOUVEL UTILISATEUR",
      "table": {
        "username": "Nom d'utilisateur",
        "email": "Email",
        "fullName": "Nom complet",
        "role": "Rôle",
        "permissions": "Permissions",
        "status": "Statut",
        "actions": "Actions"
      },
      "noUsers": "Aucun utilisateur enregistré",
      "noUsersSubtitle": "Les utilisateurs seront créés via l'API backend",
      "roles": {
        "admin": "Administrateur",
        "user": "Utilisateur",
        "viewer": "Lecteur"
      },
      "permissions": {
        "read": "Lire",
        "create": "Créer",
        "update": "Modifier",
        "delete": "Supprimer"
      },
      "modal": {
        "add": "Créer un Utilisateur",
        "edit": "Modifier l'Utilisateur",
        "username": "Nom d'utilisateur *",
        "email": "Email *",
        "password": "Mot de passe",
        "passwordEdit": "Mot de passe (laisser vide pour ne pas changer)",
        "fullName": "Nom complet",
        "role": "Rôle *",
        "status": "Statut *",
        "permissions": "Permissions",
        "createButton": "Créer",
        "saveButton": "Enregistrer"
      },
      "deleteConfirm": "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.",
      "success": {
        "add": "Utilisateur créé avec succès !",
        "edit": "Utilisateur modifié avec succès !",
        "delete": "Utilisateur supprimé avec succès !",
        "toggle": "Utilisateur {status} avec succès !"
      },
      "toggle": {
        "deactivated": "désactivé",
        "activated": "activé"
      },
      "passwordMinLength": "Le mot de passe doit contenir au moins 6 caractères"
    },
    "loading": "Chargement...",
    "error": "Erreur",
    "success": "Succès",
    "backup": {
      "manual": "Sauvegarde Manuelle",
      "creating": "Création en cours..."
    }
  },
  "profile": {
    "title": "Mon Profil",
    "tabs": {
      "info": "Informations Personnelles",
      "password": "Mot de Passe",
      "preferences": "Préférences",
      "history": "Historique"
    },
    "info": {
      "fullName": "Nom complet",
      "email": "Email",
      "phone": "Téléphone",
      "company": "Entreprise",
      "role": "Rôle",
      "save": "Enregistrer les modifications",
      "saving": "Enregistrement...",
      "success": "Profil mis à jour avec succès !"
    },
    "password": {
      "current": "Mot de passe actuel",
      "new": "Nouveau mot de passe",
      "confirm": "Confirmer le nouveau mot de passe",
      "minLength": "Minimum 8 caractères",
      "change": "Modifier le mot de passe",
      "changing": "Modification...",
      "success": "Mot de passe modifié avec succès !",
      "error": {
        "mismatch": "Les mots de passe ne correspondent pas",
        "minLength": "Le mot de passe doit contenir au moins 8 caractères"
      }
    },
    "preferences": {
      "theme": "Thème",
      "light": "Clair",
      "dark": "Sombre",
      "language": "Langue",
      "currency": "Devise par défaut",
      "notifications": "Notifications",
      "email": "Notifications par email",
      "push": "Notifications push",
      "sms": "Notifications SMS",
      "save": "Enregistrer les préférences",
      "success": "Préférences enregistrées avec succès !"
    },
    "history": {
      "title": "Historique des Connexions",
      "noHistory": "Aucun historique de connexion disponible",
      "table": {
        "date": "Date",
        "ip": "IP",
        "location": "Localisation",
        "device": "Appareil",
        "status": "Statut"
      },
      "status": {
        "success": "Succès",
        "failure": "Échec"
      }
    },
    "error": "Erreur lors de la mise à jour du profil"
  },
  "alerts": {
    "title": "Paramètres d'Alertes",
    "goldPrice": {
      "title": "Alertes Prix Or",
      "description": "Recevez des notifications lorsque le prix de l'or dépasse vos seuils",
      "minThreshold": "Seuil Minimum (USD/oz)",
      "minPlaceholder": "2500",
      "minHelp": "Alerte si prix < seuil minimum",
      "maxThreshold": "Seuil Maximum (USD/oz)",
      "maxPlaceholder": "2800",
      "maxHelp": "Alerte si prix > seuil maximum"
    },
    "stock": {
      "title": "Alertes Différences Stock",
      "description": "Recevez des notifications lorsque le stock théorique diffère du stock réel"
    },
    "margin": {
      "title": "Alertes Marges & Profits",
      "description": "Recevez des notifications lorsque la marge est en dessous du seuil minimum",
      "threshold": "Seuil Minimum de Marge (%)",
      "thresholdPlaceholder": "5",
      "thresholdHelp": "Alerte si marge < seuil minimum"
    },
    "save": "Sauvegarder les Paramètres",
    "success": {
      "title": "Paramètres sauvegardés",
      "message": "Vos paramètres d'alertes ont été sauvegardés avec succès."
    }
  },
  "footer": {
    "company": "Golden Mali SARL",
    "description": "Plateforme SaaS pour la gestion professionnelle des flux d'or et métaux précieux.",
    "legal": "Mentions Légales",
    "legalItems": {
      "legal": "Mentions Légales (à venir)",
      "privacy": "Politique de Confidentialité (à venir)",
      "terms": "CGV (à venir)"
    },
    "contact": "Contact",
    "contactDescription": "Pour toute question ou support, contactez-nous.",
    "copyright": "© {{year}} Golden Mali SARL. Tous droits réservés.",
    "developer": "Plate-forme SaaS créée par",
    "developerLink": "Créatif-web"
  },
  "accessDenied": {
    "title": "Accès Refusé",
    "message": "Vous n'avez pas les permissions nécessaires pour accéder à cette page.",
    "back": "Retour à l'accueil"
  },
  "financialFlows": {
    "export": {
      "usdPurchases": "Achats USD",
      "beneficiaryPayments": "Paiements Bénéficiaires",
      "transferRequests": "Demandes de Virement",
      "goldCommissions": "Commissions Or",
      "exportedOn": "Exporté le",
      "totalRecords": "Total",
      "records": "enregistrement(s)",
      "headers": {
        "reference": "Réf.",
        "partner": "Partenaire",
        "beneficiary": "Bénéficiaire",
        "client": "Client",
        "cfa": "CFA",
        "usd": "USD",
        "aed": "AED",
        "amountAed": "Montant AED",
        "status": "Statut",
        "period": "Période",
        "volume": "Volume",
        "commission": "Commission"
      },
      "status": {
        "paid": "payé",
        "pending_payment": "en attente",
        "cancelled": "annulé",
        "pending": "en attente",
        "partner_paid": "partenaire payé",
        "swift_received": "SWIFT reçu",
        "recipient_confirmed": "destinataire confirmé",
        "closed": "clôturé"
      }
    }
  },
  "swift": {
    "title": "Gestion des Paiements SWIFT",
    "subtitle": "Système de gestion et traçabilité des virements TT (Telegraphic Transfers)",
    "newPayment": "Nouveau Paiement SWIFT",
    "list": "Liste des Paiements",
    "create": "Créer un Paiement",
    "details": "Détails du Paiement",
    "reference": "Référence SWIFT",
    "status": "Statut",
    "amount": "Montant",
    "currency": "Devise",
    "client": "Client",
    "beneficiary": "Bénéficiaire",
    "beneficiaryName": "Nom du Bénéficiaire",
    "beneficiaryAccount": "Compte Bénéficiaire",
    "beneficiaryBank": "Banque Bénéficiaire",
    "beneficiaryBankSwift": "Code SWIFT Banque",
    "beneficiaryAddress": "Adresse Bénéficiaire",
    "sender": "Expéditeur",
    "senderName": "Nom Expéditeur",
    "senderAccount": "Compte Expéditeur",
    "senderBank": "Banque Expéditeur",
    "senderBankSwift": "Code SWIFT Banque Expéditeur",
    "transaction": "Transaction Associée",
    "partner": "Partenaire",
    "documents": "Documents",
    "history": "Historique",
    "actions": "Actions",
    "createButton": "Créer le Paiement",
    "cancelButton": "Annuler",
    "saveButton": "Enregistrer",
    "uploadDocument": "Ajouter un Document",
    "documentType": "Type de Document",
    "documentDescription": "Description",
    "selectFile": "Sélectionner un fichier",
    "noDocuments": "Aucun document",
    "noHistory": "Aucun historique",
    "statuses": {
      "pending": "Demande créée",
      "submitted": "Soumis",
      "sent_to_intermediary": "Envoyé à l'intermédiaire",
      "processing": "Virement en cours",
      "swift_received": "SWIFT reçu",
      "completed": "Paiement confirmé",
      "rejected": "Rejeté",
      "cancelled": "Annulé"
    },
    "documentTypes": {
      "invoice": "Facture",
      "contract": "Contrat",
      "receipt": "Reçu",
      "swift_confirmation": "Confirmation SWIFT",
      "other": "Autre"
    },
    "actionsMenu": {
      "sendToIntermediary": "Envoyer à l'intermédiaire",
      "markProcessing": "Marquer comme virement en cours",
      "markSwiftReceived": "Marquer SWIFT reçu",
      "complete": "Confirmer le paiement",
      "reject": "Rejeter",
      "viewDetails": "Voir les détails",
      "downloadDocument": "Télécharger",
      "deleteDocument": "Supprimer"
    },
    "form": {
      "required": "Ce champ est obligatoire",
      "invalidAmount": "Le montant doit être supérieur à 0",
      "invalidSwiftCode": "Code SWIFT invalide (format: 8 ou 11 caractères)",
      "success": "Paiement SWIFT créé avec succès",
      "error": "Erreur lors de la création du paiement"
    },
    "filters": {
      "all": "Tous",
      "status": "Filtrer par statut",
      "client": "Filtrer par client",
      "partner": "Filtrer par partenaire"
    },
    "table": {
      "reference": "Référence",
      "client": "Client",
      "beneficiary": "Bénéficiaire",
      "amount": "Montant",
      "status": "Statut",
      "createdAt": "Date de création",
      "actions": "Actions",
      "noPayments": "Aucun paiement SWIFT"
    },
    "modal": {
      "confirmReject": "Êtes-vous sûr de vouloir rejeter ce paiement ?",
      "rejectReason": "Raison du rejet",
      "confirmComplete": "Confirmer le paiement",
      "bankReference": "Référence bancaire",
      "processingNotes": "Notes de traitement"
    },
    "success": {
      "created": "Paiement SWIFT créé avec succès",
      "sentToIntermediary": "Paiement envoyé à l'intermédiaire avec succès",
      "markedProcessing": "Paiement marqué comme en cours de traitement",
      "markedSwiftReceived": "Paiement marqué comme SWIFT reçu",
      "completed": "Paiement confirmé avec succès",
      "rejected": "Paiement rejeté",
      "documentUploaded": "Document uploadé avec succès",
      "documentDeleted": "Document supprimé avec succès"
    },
    "error": {
      "load": "Erreur lors du chargement des paiements",
      "create": "Erreur lors de la création",
      "update": "Erreur lors de la mise à jour",
      "upload": "Erreur lors de l'upload du document",
      "delete": "Erreur lors de la suppression"
    }
  },
  "cookies": {
    "title": "Gestion des Cookies",
    "subtitle": "Nous utilisons des cookies pour améliorer votre expérience",
    "description": "Cette plateforme utilise des cookies pour assurer le bon fonctionnement du site, mémoriser vos préférences et améliorer votre expérience utilisateur. En continuant à utiliser cette plateforme, vous acceptez l'utilisation de cookies conformément à notre politique de confidentialité.",
    "types": {
      "title": "Types de cookies utilisés",
      "essential": {
        "title": "Cookies essentiels",
        "description": "Nécessaires au fonctionnement de la plateforme (authentification, sécurité, préférences de langue)"
      },
      "functional": {
        "title": "Cookies fonctionnels",
        "description": "Améliorent votre expérience (mémorisation des préférences, synchronisation des données)"
      },
      "analytics": {
        "title": "Cookies d'analyse",
        "description": "Nous aident à comprendre comment vous utilisez la plateforme (statistiques anonymes)"
      }
    },
    "moreInfo": "Pour plus d'informations, consultez notre politique de confidentialité.",
    "accept": "J'accepte",
    "reject": "Je refuse"
  }
};

export default fr;
